export const getStatusDisplayName = status => {
  if (status.includes('_')) {
    const changedStatus = status.replace('_', ' ');
    return changedStatus.slice(0, 2).toUpperCase() + changedStatus.slice(2).toLowerCase();
  } else {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }
};
